/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Computer_Science20Inputs */

const en__field_enum_icsrm_computer_science20 = /** @type {(inputs: _Field_Enum_Icsrm_Computer_Science20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computer Science`)
};

const de__field_enum_icsrm_computer_science20 = /** @type {(inputs: _Field_Enum_Icsrm_Computer_Science20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informatik`)
};

/**
* | output |
* | --- |
* | "Computer Science" |
*
* @param {_Field_Enum_Icsrm_Computer_Science20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_computer_science20 = /** @type {((inputs?: _Field_Enum_Icsrm_Computer_Science20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Computer_Science20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_computer_science20(inputs)
	return de__field_enum_icsrm_computer_science20(inputs)
});
export { _field_enum_icsrm_computer_science20 as "_field_enum_ICSRM_COMPUTER_SCIENCE" }